import NavBar from "@components/layout/Navbar/Navbar";
import Image from "@components/core/Image";
import Link from "@components/core/Link";
import PromoBannerContainer from "@components/layout/PromoBannerContainer";

function HeaderOnboarding() {
  return (
    <>
      <PromoBannerContainer />
      <header className="sticky-top">
        <NavBar className="navbar-logo-only">
          <Link
            href="/home"
            className="link-dark d-flex"
          >
            <Image
              src="logo"
              alt="logo"
              style={{ height: "24px" }}
            />
          </Link>
        </NavBar>
      </header>
    </>
  );
}

export default HeaderOnboarding;
